export default __webpack_public_path__ + "static/media/landinglazy3.559fe061.jpg";